import { action, observable, makeObservable } from 'mobx';

class GameStore {
  odd = 0;

  hasAutoBet = false;

  oddsInfo = [];

  spinResult = {};

  noWinMatrix = [];

  replayData = null;

  isSpinStart = false;

  gameFreeSpinRemainingCount = null;

  gameInitialMatrix = [];

  isGameFreeSpin = false;

  isExpandWildOpen = false;

  isNeedGetBalance = false;

  isNeedSpinAction = false;

  isGameFreeSpinStart = false;

  gameFreeSpinTotalWin = 0;

  constructor() {
    makeObservable(this, {
      odd: observable,
      replayData: observable,
      isSpinStart: observable,
      noWinMatrix: observable,
      hasAutoBet: observable,
      isGameFreeSpin: observable,
      isNeedSpinAction: observable,
      isExpandWildOpen: observable,
      isNeedGetBalance: observable,
      isGameFreeSpinStart: observable,
      gameFreeSpinTotalWin: observable,
      gameFreeSpinRemainingCount: observable,
      oddsInfo: observable.deep,
      spinResult: observable.deep,
      gameInitialMatrix: observable.deep,
      setOdd: action.bound,
      setOddsInfo: action.bound,
      setHasAutoBet: action.bound,
      setSpinResult: action.bound,
      setReplayData: action.bound,
      setIsSpinStart: action.bound,
      setNoWinMatrix: action.bound,
      setIsGameFreeSpin: action.bound,
      setIsNeedGetBalance: action.bound,
      setIsExpandWildOpen: action.bound,
      setIsNeedSpinAction: action.bound,
      setGameInitialMatrix: action.bound,
      setIsGameFreeSpinStart: action.bound,
      setGameFreeSpinTotalWin: action.bound,
      setGameFreeSpinRemainingCount: action.bound,
    });
  }

  setReplayData(data) {
    this.replayData = data;
  }

  setHasAutoBet(bool) {
    this.hasAutoBet = bool;
  }

  setIsGameFreeSpin(bool) {
    this.isGameFreeSpin = bool;
  }

  setIsGameFreeSpinStart(bool) {
    this.isGameFreeSpinStart = bool;
  }

  setGameFreeSpinRemainingCount(number) {
    this.gameFreeSpinRemainingCount = number;
  }

  setGameFreeSpinTotalWin(amount) {
    this.gameFreeSpinTotalWin = amount;
  }

  setIsExpandWildOpen(bool) {
    this.isExpandWildOpen = bool;
  }

  setIsNeedSpinAction(bool) {
    this.isNeedSpinAction = bool;
  }

  setIsNeedGetBalance(bool) {
    this.isNeedGetBalance = bool;
  }

  setNoWinMatrix(matrix) {
    this.noWinMatrix = matrix;
  }

  setOdd(value) {
    this.odd = value;
  }

  setSpinResult(spinResult) {
    this.spinResult = spinResult;
  }

  setGameInitialMatrix(matrix) {
    this.gameInitialMatrix = matrix;
  }

  setOddsInfo(oddsInfo) {
    this.oddsInfo = oddsInfo;
  }

  setIsSpinStart(bool) {
    this.isSpinStart = bool;
  }

  resetGameStore() {
    this.odd = 0;
    this.oddsInfo = [];
    this.spinResult = {};
    this.replayData = null;
    this.isSpinStart = false;
    this.isGameFreeSpin = false;
    this.isExpandWildOpen = false;
    this.isNeedGetBalance = false;
    this.isNeedSpinAction = false;
    this.isGameFreeSpinStart = false;
    this.gameFreeSpinRemainingCount = null;
  }
}

export const gameStore = new GameStore();
